module.exports = __webpack_public_path__ + "img/Layer_3.f1132634.png";